import {filter, fromEvent} from "rxjs";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {erIkkeNil, erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {nil} from "felles-ng2/typer/nullish";

/** kaller angitt metode når bruker klikker på esc-tasten. */
export function lyttTilEsc(vedEsc: () => void) {
    escapeTastTrykket().subscribe(() => vedEsc());
}

/** Returnerer observerbar som leverer hver gang bruker klikker på esc-tasten. */
export function escapeTastTrykket() {
    return fromEvent<KeyboardEvent>(document, 'keydown')
      .pipe(
        filter(event => event.key === Tastatur.Escape),
        takeUntilDestroyed()
      );
}

export function erClipboardEvent(hendelse: Event | nil): hendelse is ClipboardEvent {
    if (erNil(hendelse)) return false;
    if (erIkkeNil((<any>hendelse).clipboardData)) return true;
    return false;
}

export type ModifierKeys = 'Alt' | 'AltGraph' | 'CapsLock' | 'Control' | 'Fn' | 'FnLock' | 'Hyper' | 'Meta' | 'NumLock' | 'ScrollLock' | 'Shift' | 'Super' | 'Symbol' | 'SymbolLock'
export type WhitespaceKeys = 'Enter' | 'Tab' | ' '
export type NavigationKeys = 'ArrowDown' | 'ArrowLeft' | 'ArrowRight' | 'ArrowUp' | 'End' | 'Home' | 'PageDown' | 'PageUp'
export type EditingKeys = 'Backspace' | 'Clear' | 'Copy' | 'CrSel' | 'Cut' | 'Delete' | 'EraseEof' | 'ExSel' | 'Insert' | 'Paste' | 'Redo' | 'Undo'
export type UIKeys = 'Accept' | 'Again' | 'Attn' | 'Cancel' | 'ContextMenu' | 'Escape' | 'Execute' | 'Find' | 'Finish' | 'Help' | 'Pause' | 'Play' | 'Props' | 'Select' | 'ZoomIn' | 'ZoomOut'

/** Definerer et utvalg av mulige verdier for {@link KeyboardEvent#key}
 * Se https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values*/
export type SpesialtegnType = ModifierKeys | WhitespaceKeys | NavigationKeys | EditingKeys | UIKeys

// litt krøkkete måte å sørge for at Tastatur blir read-only
const _Tastatur = {
    Escape: 'Escape',
    ArrowDown: 'ArrowDown',
    ArrowLeft: 'ArrowLeft',
    ArrowRight: 'ArrowRight',
    ArrowUp: 'ArrowUp',
    End: 'End',
    Home: 'Home',
    PageDown: 'PageDown',
    PageUp: 'PageUp'
}

/** Navn på utvlagte {@link KeyboardEvent#key} */
export const Tastatur: Readonly<typeof _Tastatur> = _Tastatur
